import {z} from 'zod';
import {
  RECRUITMENT_SCHEDULE_WARNING_CTRL,
  RECRUITMENT_SCHEDULE_WARNING_STATUS,
} from '../../../core/entities/recruitment/constants';
import type {RecruitmentScheduleWarning} from '../../../core/entities/recruitment/schema';

const returnValue = z.enum([
  RECRUITMENT_SCHEDULE_WARNING_STATUS.OK,
  RECRUITMENT_SCHEDULE_WARNING_STATUS.ENTRY_DEADLINE_OVER,
  RECRUITMENT_SCHEDULE_WARNING_STATUS.EVENT_END_OVER,
  RECRUITMENT_SCHEDULE_WARNING_STATUS.CONTRACT_END_OVER,
]);
type ReturnValue = z.infer<typeof returnValue>;

export const getScheduleWarningStatus = (
  scheduleWarning: RecruitmentScheduleWarning,
  displayEndAt?: string,
): ReturnValue => {
  // 強制非表示の場合
  if (scheduleWarning.ctrl === RECRUITMENT_SCHEDULE_WARNING_CTRL.ALWAYS_OFF) {
    return RECRUITMENT_SCHEDULE_WARNING_STATUS.OK;
  }

  // 強制表示の場合
  if (scheduleWarning.ctrl === RECRUITMENT_SCHEDULE_WARNING_CTRL.ALWAYS_ON) {
    // 警告レベルが「開催終了」の場合は「開催終了」、それ以外は「募集終了」と表示

    if (scheduleWarning.code === 'EVENT_END_OVER') {
      return RECRUITMENT_SCHEDULE_WARNING_STATUS.EVENT_END_OVER;
    }

    return RECRUITMENT_SCHEDULE_WARNING_STATUS.ENTRY_DEADLINE_OVER;
  }

  if (scheduleWarning.code === 'OK') {
    return RECRUITMENT_SCHEDULE_WARNING_STATUS.OK;
  }

  // 警告レベルが「開催終了」の場合
  if (scheduleWarning.code === 'EVENT_END_OVER') {
    return RECRUITMENT_SCHEDULE_WARNING_STATUS.EVENT_END_OVER;
  }

  // 警告レベルが「募集終了」の場合
  if (scheduleWarning.code === 'ENTRY_DEADLINE_OVER') {
    return RECRUITMENT_SCHEDULE_WARNING_STATUS.ENTRY_DEADLINE_OVER;
  }

  // 警告レベルが「判別不能」の場合
  if (
    scheduleWarning.code === 'UNDETERMINABLE' &&
    displayEndAt &&
    new Date(displayEndAt) < new Date()
  ) {
    return RECRUITMENT_SCHEDULE_WARNING_STATUS.CONTRACT_END_OVER;
  }

  return RECRUITMENT_SCHEDULE_WARNING_STATUS.OK;
};
